家庭情况（原“其他”）

<template>
  <div class="applyInitiation_personal applyInitiation_other">
    <div class="applyInitiation_personal_head">
      <span>家庭情况</span>
      <span class="red">(选填)</span>
    </div>
    <div class="applyInitiation_personal_main">
      <ul class="applyInitiation_personal_list clearfix">
        <li class="clearfix">
          <div class="applyInitiation_personal_list_name left">兄弟姐妹几人</div>
          <el-select :disabled="isDisabled" v-model="otherFormData.re_bro_sis" placeholder="请选择">
            <el-option v-for="(item, index) in brotherList" :key="index" :label="item" :value="item"> </el-option>
          </el-select>
        </li>

        <li class="clearfix">
          <div class="applyInitiation_personal_list_name left">父亲情况</div>
          <el-select :disabled="isDisabled" v-model="otherFormData.re_father" placeholder="请选择">
            <el-option v-for="(item, index) in fatherList" :key="index" :label="item" :value="item"> </el-option>
          </el-select>
        </li>
        <li class="clearfix">
          <div class="applyInitiation_personal_list_name left">父亲工作情况</div>
          <el-select :disabled="isDisabled" v-model="otherFormData.re_father_job" placeholder="请选择">
            <el-option v-for="(item, index) in fatherJobList" :key="index" :label="item" :value="item"> </el-option>
          </el-select>
        </li>
        <li class="clearfix">
          <div class="applyInitiation_personal_list_name left">父亲是否有退休金</div>
          <el-select :disabled="isDisabled" v-model="otherFormData.re_father_pension" placeholder="请选择">
            <el-option v-for="(item, index) in fatherPensionList" :key="index" :label="item" :value="item"> </el-option>
          </el-select>
        </li>
        <li class="clearfix">
          <div class="applyInitiation_personal_list_name left">母亲情况</div>
          <el-select :disabled="isDisabled" v-model="otherFormData.re_mather" placeholder="请选择">
            <el-option v-for="(item, index) in fatherList" :key="index" :label="item" :value="item"> </el-option>
          </el-select>
        </li>
        <li class="clearfix">
          <div class="applyInitiation_personal_list_name left">母亲工作情况</div>
          <el-select :disabled="isDisabled" v-model="otherFormData.re_mather_job" placeholder="请选择">
            <el-option v-for="(item, index) in fatherJobList" :key="index" :label="item" :value="item"> </el-option>
          </el-select>
        </li>
        <li class="clearfix">
          <div class="applyInitiation_personal_list_name left">母亲是否有退休金</div>
          <el-select :disabled="isDisabled" v-model="otherFormData.re_mather_pension" placeholder="请选择">
            <el-option v-for="(item, index) in fatherPensionList" :key="index" :label="item" :value="item"> </el-option>
          </el-select>
        </li>
      </ul>
      <div class="copy" @click="handleSubmitOther" v-if="!isDisabled">保存并继续</div>
    </div>
  </div>
</template>

<script>
/* 
  为什么用 mather 而不是 mother
    后端数据库字段名是 mather
                              -- 2025-02-28
*/

import $DB from '../../../util/debounce'

export default {
  name: 'Other',
  props: {
    // 用户信息
    userInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      otherInfo: { re_status: 0 }, // 其他信息

      brotherList: [], // 兄弟列表
      fatherList: [], // 父母情况列表
      fatherJobList: [], // 父母工作情况列表
      fatherPensionList: [], // 父母是否有退休金列表

      otherFormData: {
        re_bro_sis: '', // 兄弟姐妹几人

        // 202406 新增
        re_father: '', // 父亲情况
        re_father_job: '', // 父亲工作情况
        re_father_pension: '', // 父亲是否有退休金
        re_mather: '', // 母亲情况
        re_mather_job: '', // 母亲工作情况
        re_mather_pension: '', // 母亲是否有退休金
      },
    }
  },
  computed: {
    isDisabled() {
      return this.userInfo.check_status === 2 || this.userInfo.check_status === 3
    },
  },
  created() {
    this.funLoadOther()

    // 类型:1性别:2 民族;3身高;4体重:5属相;6星座:7血型;8信仰;9 籍贯;10长期居住地;11学历;12毕业院校【对应School表];13公司类型:14职业:15收入:16兄弟姐妹几人;17婚姻状况:18住房情况:19买车情况:20是否抽烟;21是否喝酒;22是否有孩子;23 有几个孩子:24 是否想要孩子;25 何时结婚;26年龄;27身高;28期待结婚时间;29所在地:30推荐指数;32 工作性质;33住房是否有贷款;34车辆是否有贷款;35父母亲情况;36父母亲工作情况;37父母亲是否有退休金;38是否原生家庭;39感情经历:40孩子情况:41抚养费;
    const obj = {
      16: 'brotherList', // 兄弟列表

      35: 'fatherList', // 父母情况列表
      36: 'fatherJobList', // 父母工作情况列表
      37: 'fatherPensionList', // 父母是否有退休金列表
    }
    for (const key in obj) {
      this.funLodeCateList(+key, obj[key])
    }
  },
  methods: {
    //获取其它信息
    funLoadOther() {
      this.$axios.post('/api/member/getUserRests').then((res) => {
        this.otherInfo.re_status = res.data.data.re_status
        if (res.data.code === 0) {
          this.otherInfo = res.data.data
          for (const key in this.otherFormData) {
            this.otherFormData[key] = this.otherInfo[key]
          }
        }
      })
    },

    /**
     * 获取下拉选择内容
     * @param {Number} type 类型
     * @param {String} propName data 中的字段名
     */
    funLodeCateList(type, propName) {
      this.$axios.post('/api/index/cateList', { type }).then((res) => {
        if (res.data.code === 0) {
          this[propName] = res.data.data[0].cate_name
        }
      })
    },

    //上传其它
    handleSubmitOther: $DB(function () {
      // if (!this.other.re_bro_sis) return this.$message.error('请选择兄弟姐妹情况')
      // if (!this.other.re_marital_status) return this.$message.error('请选择婚姻情况')
      // if (!this.other.re_child_num) return this.$message.error('请选择孩子数量')

      this.$axios.post('/api/member/userRests', this.otherFormData).then((res) => {
        if (res.data.code === 0) {
          this.$message.success(res.data.msg)
        } else {
          this.$message.error(res.data.msg)
        }
      })
    }),
  },
}
</script>

<style lang="scss" src="../index.scss" scoped></style>
